import paginationScroll from './pagination-scroll';

const relatedPostsScroll = () => {
  const url = window.location.href;
  const offset = 28;
  const timeout = 150;
  if (url.includes('page/') || url.includes('ks_results_match')) {
    setTimeout(() => {
      paginationScroll(offset);
    }, timeout);
  }
};

export default relatedPostsScroll;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/relatedPostsScroll.js